import * as React from 'react';
import { Fragment } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { useSelector } from 'react-redux';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Rider from './Rider';
import Online from './Online';
import Offline from './Offline';
import Editor from './Editor';
import Admin from './Admin';

const drawerWidth = 220;

export default function SideBarDesktop() {
  const user = useSelector((state) => state.user.user);
  const isAuth = useSelector((state) => state.auth.isAuthenticated);  
  const userRole = useSelector((state) => state.user.currentRole);

  const shortenAddress = (address) => {
    if (!address) return '';
    if (address.length > 9) {
      return address.substring(0, 3) + '...' + address.substring(address.length - 6);
    }
    return address;
  };

  const getInitial = (name) => {
    if (!name) return 'A';
    return name.charAt(0).toUpperCase();
  };

  return (
    <Box sx={{ display: {md: 'flex', sm: 'none', xs: 'none'} }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', bgcolor: '#1a1a1a' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto', bgcolor: '#1a1a1a', minHeight: 'calc(100vh - 64px)' }}>
          {(user.name && isAuth) && 
          <Link to='/profile' component={RouterLink} sx={{ width: '100%', textDecoration: 'none', color: 'inherit', maxWidth: 360, bgcolor: '#1a1a1a' }}>
            <ListItem alignItems="flex-start" sx={{ paddingY: '20px', paddingX: '16px', bgcolor: '#1a1a1a' }}>
            <ListItemAvatar>
              <Avatar 
                alt={user.name} 
                src={user.profile}
                sx={{ 
                  bgcolor: '#424242', 
                  color: 'white',
                  width: 48,
                  height: 48,
                  fontSize: '20px',
                  fontWeight: 'bold'
                }}
              >
                {!user.profile && getInitial(user.name)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ color: 'white', fontFamily: 'sans-serif', fontWeight: '500', fontSize: '16px' }}>
                  Aureum Vault
                </Typography>
              }
              secondary={
                <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)', fontFamily: 'sans-serif', fontSize: '12px' }}>
                  {shortenAddress(user.email || 'wyomingllcattorney.com')}
                </Typography>
              }
            />
          </ListItem>
        </Link>
          }
          
        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}/>
          
          {isAuth && user.name ?
            userRole === '' ?
            <Online/>
            : 
            <Fragment>
               {userRole === 'admin' && <Admin/>}      
               {userRole === 'editor' && <Editor/>}
               {userRole === 'dispatch rider' && <Rider/>}              
            </Fragment>
                   
          :
          <Offline/>
          }

        </Box>
      </Drawer>
      
    </Box>
  );
}
